import { useTestsheetsPageVM } from './useTestsheetsPageVM';
import './TestsheetsPage.scss';
import { HeaderToggle, ListItem, TestsheetCard } from '@components';
import { Button, Container, Modal, Typography } from '@design-system';
import { BiPlus } from 'react-icons/bi';
import { TestsheetSkeleton } from './TestsheetSkeleton';

export const TestsheetsPage = () => {
    const { isLoading, waitingTestsheets, validatedTestsheets, testsheets, navigate, isModalOpen, setIsModalOpen } = useTestsheetsPageVM();

    return (
        <div className="testsheets-page">
            <HeaderToggle labels={['En cours', 'Traités']}>
                <Container className="waiting-testsheet-container">
                    {isLoading ? (
                        <TestsheetSkeleton />
                    ) : (
                        <>
                            {waitingTestsheets.length > 0 ? (
                                waitingTestsheets.map((testsheet) => <TestsheetCard key={testsheet.id} testsheet={testsheet} />)
                            ) : (
                                <Typography intrinsic="p" color="grey" defaultSpacing>
                                    Aucun essai en cours
                                </Typography>
                            )}
                        </>
                    )}
                </Container>
                <Container className="validated-testsheet-container">
                    {isLoading ? (
                        <TestsheetSkeleton />
                    ) : (
                        <>
                            {validatedTestsheets.length > 0 ? (
                                validatedTestsheets.map((testsheet) => <TestsheetCard key={testsheet.id} testsheet={testsheet} />)
                            ) : (
                                <Typography intrinsic="p" color="grey" defaultSpacing>
                                    Aucun essai traité
                                </Typography>
                            )}
                        </>
                    )}
                </Container>
            </HeaderToggle>

            <div className="floating-button">
                <Button
                    color="marine"
                    size="fullwidth"
                    icon={<BiPlus />}
                    iconColor="white"
                    iconPosition="forced-left"
                    iconSize={28}
                    onClick={() => setIsModalOpen(true)}
                >
                    <Typography intrinsic="h4">Nouvel essai</Typography>
                </Button>
            </div>

            <Modal open={isModalOpen} setClose={() => setIsModalOpen(false)} title="Nouvel essai">
                <div className="testsheets-modal-list">
                    {testsheets.map((testsheet) => {
                        const parts = testsheet.title.split('// ');
                        const hasCode = parts.length > 1;
                        const code = hasCode ? parts[0].trim() : null;
                        const title = hasCode ? parts.slice(1).join('// ').trim() : testsheet.title;

                        return (
                            <ListItem
                                key={testsheet.id}
                                title={title}
                                tag={code}
                                icon={null}
                                onClick={() => {
                                    navigate(`/mes-chantiers/testsheets/create/${testsheet.id}`);
                                }}
                                type="default"
                            />
                        );
                    })}
                </div>
            </Modal>
        </div>
    );
};
